export class ratePlan {
  constructor({
    id = 0,
    ratePlanID = 0,
    ratePlanDescription = null,
    groupName = null,
    usageType = null,
    handset = false,
    monthlyRetail = 0,
    monthlyProfitPercent = 0,
    ratePlanPDF = null,
    dataAllowance = 0,
    contractMonths = 0,
    payInitialComms = false,
    hasSpecialOverride = false,
    dealerSupplied = false,
    mixnMatch = false,
    additionalServices = false,
    residential = false,
    monitorDataUsage = false,
    pooledAllowance = false,
    emailNotification = false,
    resourceFileID = null,
    qantas = false,
    ipBundle = false,
    imagePath = null,
    softphoneNoCharge = false,
    rentalHardware = false
      
  } = {}) {
    this.id = id;
    this.ratePlanID = ratePlanID;
    this.ratePlanDescription = ratePlanDescription;
    this.groupName = groupName;
    this.usageType = usageType;
    this.handset = handset;
    this.monthlyRetail = monthlyRetail;
    this.monthlyProfitPercent = monthlyProfitPercent;
    this.ratePlanPDF = ratePlanPDF;
    this.dataAllowance = dataAllowance;
    this.contractMonths = contractMonths;
    this.payInitialComms = payInitialComms;
    this.hasSpecialOverride = hasSpecialOverride;
    this.additionalServices = additionalServices;
    this.residential = residential;
    this.dealerSupplied = dealerSupplied;
    this.mixnMatch = mixnMatch;
    this.monitorDataUsage = monitorDataUsage;
    this.pooledAllowance = pooledAllowance;
    this.emailNotification = emailNotification;
    this.resourceFileID = resourceFileID;
    this.qantas = qantas;
    this.ipBundle = ipBundle;
    this.imagePath = imagePath;
    this.softphoneNoCharge = softphoneNoCharge;
    this.rentalHardware = rentalHardware;
  }
}

export function createRatePlan(data) {
  return Object.freeze(new ratePlan(data));
}
